import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/usr/src/app/src/layouts/account.vue").then(m => m.default || m)),
  cbz: defineAsyncComponent(() => import("/usr/src/app/src/layouts/cbz.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/usr/src/app/src/layouts/default.vue").then(m => m.default || m)),
  protected: defineAsyncComponent(() => import("/usr/src/app/src/layouts/protected.vue").then(m => m.default || m))
}